var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMixCardPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6225_20023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4704 14.1176C26.4711 14.4172 26.3943 14.7119 26.2474 14.973C26.1005 15.2341 25.8885 15.4528 25.6321 15.6077L9.74095 25.329C9.47303 25.4931 9.16617 25.5826 8.85206 25.5885C8.53796 25.5943 8.22799 25.5161 7.95418 25.3621C7.68298 25.2105 7.45706 24.9893 7.29966 24.7214C7.14225 24.4535 7.05905 24.1486 7.05859 23.8378V4.3974C7.05905 4.08669 7.14225 3.7817 7.29966 3.5138C7.45706 3.24591 7.68298 3.02477 7.95418 2.87314C8.22799 2.71911 8.53796 2.64097 8.85206 2.64679C9.16617 2.6526 9.47303 2.74217 9.74095 2.90623L25.6321 12.6275C25.8885 12.7825 26.1005 13.0011 26.2474 13.2622C26.3943 13.5234 26.4711 13.818 26.4704 14.1176Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6225_20023"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.2353,
    height: 28.2353,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMixCardPlay);
export default __webpack_public_path__ + "static/media/mix-card-play.a130d445dcfd171f69b6e1ddcecd39be.svg";
export { ForwardRef as ReactComponent };